import {Platform, Share, ShareContent, StyleSheet, View, ViewStyle} from "react-native";
import {useRouter} from "expo-router";
import ErrorPage from "@/lib/components/ErrorPage";
import SpinnerPage from "@/lib/components/SpinnerPage";
import {useState} from "react";
import Page from "@/lib/components/Page";
import {API_URL, BASE_URL} from "@/lib/constants";
import {SvgUri} from "react-native-svg";
import Center from "@/lib/components/Center";
import Header from "@/lib/components/Header";
import Location from "@/lib/components/Location";
import Timestamp from "@/lib/components/Timestamp";
import Nav from "@/lib/components/Nav";
import ActionButton from "@/lib/components/ActionButton";
import * as Clipboard from 'expo-clipboard';
import {useEvent} from "@/lib/components/EventProvider";

export default function SharePage() {
    const [copied, setCopied] = useState(false);
    const router = useRouter();

    const {event, eventLoading, eventError} = useEvent();

    if (eventError) {
        return <ErrorPage error={eventError}/>
    } else if (eventLoading || !event) {
        return <SpinnerPage/>
    }

    const qrcodeSource = API_URL + `/event/${event.event_id}/qrcode`;
    const selfURL = BASE_URL + `/e/${event.event_id}`;
    const metadataStyle: ViewStyle = {
        borderColor: event.color,
    };
    const shareData: ShareContent | undefined = (() => {
        if (Platform.OS === "android") {
            return {message: selfURL}
        } else if (Platform.OS === "ios") {
            return {url: selfURL}
        }
    })();

    return (
        <Page>
            <Center width={330} style={{alignItems: "center"}}>
                <SvgUri uri={qrcodeSource} width={330} height={330} style={{maxWidth: "100%"}}/>
                <View style={[styles.metadata, metadataStyle]}>
                    <Header title={event.title}/>
                    <Timestamp start={new Date(event.start)} end={event.end ? new Date(event.end) : null}
                               oneLineOnly={true}/>
                    {event.location && <Location>{event.location}</Location>}
                </View>
                <Nav centered={true}>
                    {(Platform.OS === "ios" || Platform.OS === "android") &&
                        <ActionButton
                            icon={"share"}
                            title={"Del eventet"}
                            onPress={async () => {
                                await Share.share(shareData!);
                                router.dismiss();
                            }}
                        />
                    }
                    {Platform.OS !== "ios" &&
                        <ActionButton
                            icon={"link"}
                            title={(copied ? "Kopiert!" : "Kopier lenke")}
                            disabled={copied}
                            onPress={async () => {
                                await Clipboard.setStringAsync(selfURL);
                                setCopied(true);
                                setTimeout(() => setCopied(false), 1000);
                            }}
                        />
                    }
                </Nav>
            </Center>
        </Page>
    )
}

export const styles = StyleSheet.create({
    metadata: {
        width: "100%",
        flexDirection: "column",
        gap: 8,
        borderWidth: 1,
        borderRadius: 8,
        padding: 12,
    },
})